import { RenewVisaListPage } from "@/features/renew-visa/pages/RenewVisaList";

const RenewVisaList = () => {
  return <RenewVisaListPage />;
};

export default RenewVisaList;
